/**
 * SM Quote Item (Twitter/X Post) Component
 * Handles video modal triggers and inline video playback
 */

(function() {
  // Global video manager to track and control all playing videos
  // (May already be defined by sm-video-item.js)
  if (!window.VideoManager) {
    window.VideoManager = {
      activeVideos: new Set(),
      
      register(videoElement, stopFn) {
        this.activeVideos.add({ element: videoElement, stop: stopFn });
      },
      
      unregister(videoElement) {
        this.activeVideos.forEach(video => {
          if (video.element === videoElement) {
            this.activeVideos.delete(video);
          }
        });
      },
      
      stopAll(except = null) {
        this.activeVideos.forEach(video => {
          if (video.element !== except) {
            video.stop();
          }
        });
      }
    };
  }
  
  function initSmQuoteItems() {
    // Modal triggers
    const triggers = document.querySelectorAll('.sm-quote-item [data-video-modal-trigger]:not([data-video-bound])');
    
    triggers.forEach(trigger => {
      trigger.setAttribute('data-video-bound', 'true');
      trigger.addEventListener('click', function() {
        const videoType = this.dataset.videoType;
        
        // Stop all playing videos before opening modal
        window.VideoManager.stopAll();
        
        if (window.VideoModal) {
          const config = {
            triggerElement: this,
            size: 'fullscreen'
          };
          
          if (videoType === 'vimeo') {
            config.type = 'vimeo';
            config.vimeoId = this.dataset.vimeoId;
          } else if (videoType === 'youtube') {
            config.type = 'youtube';
            config.youtubeId = this.dataset.youtubeId;
          } else if (videoType === 'shopify') {
            config.type = 'shopify';
            config.shopifyVideoSrc = this.dataset.shopifyVideoSrc;
          }
          
          window.VideoModal.open(config);
        }
      });
    });

    // Inline video click-to-play functionality
    const inlineVideos = document.querySelectorAll('.sm-quote-item [data-sm-quote-video]:not([data-video-bound])');
    
    inlineVideos.forEach(videoContainer => {
      videoContainer.setAttribute('data-video-bound', 'true');
      const poster = videoContainer.querySelector('.sm-quote-item__video-poster');
      const playerContainer = videoContainer.querySelector('.sm-quote-item__video-player-container');
      
      if (!poster || !playerContainer) return;
      
      poster.addEventListener('click', function() {
        const videoType = videoContainer.dataset.videoType;
        
        // Stop all other playing videos first
        window.VideoManager.stopAll();
        
        // Hide poster, show player
        poster.style.display = 'none';
        playerContainer.style.display = 'block';
        videoContainer.classList.add('video-playing');
        
        if (videoType === 'vimeo' && window.VimeoPlayerComponent) {
          const vimeoId = videoContainer.dataset.vimeoId;
          const player = new window.VimeoPlayerComponent(playerContainer, {
            vimeoId: vimeoId,
            autoplay: true,
            muted: false,
            loop: false,
            showControls: true,
            fillContainer: true
          });
          
          // Register with video manager
          window.VideoManager.register(videoContainer, () => {
            if (player && player.player) {
              player.player.pause();
            }
            playerContainer.innerHTML = '';
            playerContainer.style.display = 'none';
            poster.style.display = '';
            videoContainer.classList.remove('video-playing');
            window.VideoManager.unregister(videoContainer);
          });
        } else if (videoType === 'youtube') {
          const youtubeId = videoContainer.dataset.youtubeId;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          playerContainer.appendChild(iframe);
          
          // Register with video manager
          window.VideoManager.register(videoContainer, () => {
            playerContainer.innerHTML = '';
            playerContainer.style.display = 'none';
            poster.style.display = '';
            videoContainer.classList.remove('video-playing');
            window.VideoManager.unregister(videoContainer);
          });
        } else if (videoType === 'shopify') {
          const videoSrc = videoContainer.dataset.shopifyVideoSrc;
          const video = document.createElement('video');
          video.src = videoSrc;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          playerContainer.appendChild(video);
          
          // Register with video manager
          window.VideoManager.register(videoContainer, () => {
            video.pause();
            video.currentTime = 0;
            playerContainer.innerHTML = '';
            playerContainer.style.display = 'none';
            poster.style.display = '';
            videoContainer.classList.remove('video-playing');
            window.VideoManager.unregister(videoContainer);
          });
        }
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmQuoteItems);
  } else {
    initSmQuoteItems();
  }
  
  // Re-init on Shopify section events
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSmQuoteItems);
  }
  
  // Expose for external re-initialization if needed
  window.initSmQuoteItems = initSmQuoteItems;
})();
